import React from 'react';
import PropTypes from 'prop-types';

const LandingArrow = ({ 
  size = 16, 
  className = '', 
  color = 'currentColor',
  ...props 
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M7 7L17 17"/>
    <path d="M17 7L17 17L7 17"/>
  </svg>
);

LandingArrow.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

export default LandingArrow;